package org.braunequip.web.util

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.braunequip.web.components.forms.PortalPinForm
import org.braunequip.web.components.models.ContactsDTO
import org.braunequip.web.components.models.DieselFuelLogDTO
import org.braunequip.web.components.models.EquipRepairRequestDTO
import org.braunequip.web.components.models.TimeOffRequestDTO
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text
import org.w3c.fetch.*

val jsonSerializer = Json { encodeDefaults = true }

/*
   -------------------------------------

          CONTACT FORM FUNCTIONS

   -------------------------------------
 */

suspend fun submitContact(
    contact: ContactsDTO
): Boolean {
    val jsonData = jsonSerializer.encodeToString(contact)

    val response: Response? = try {
        window.fetch(
            input = BackendRoutes.CONTACT,
            RequestInit(
                method = "POST",
                headers = Headers().apply {
                    append("Content-Type", "application/json")
                },
                body = jsonData
            )
        ).await()
    } catch (e: Exception) {
        console.log("Error: $e")
        null
    }

   return response?.ok == true
}

/*
    -------------------------------------

           TIME OFF REQUEST FUNCTIONS

    -------------------------------------
*/

suspend fun submitTimeOffRequest(
    timeOffRequestDTO: TimeOffRequestDTO,
    onFinish: (String) -> Unit,
) {
    val jsonSerializer = Json { encodeDefaults = true }
    val jsonData = jsonSerializer.encodeToString(timeOffRequestDTO)

    val response: Response? = try {
        window.fetch(
            input = BackendRoutes.TIME_OFF_REQUEST,
            RequestInit(
                method = "POST",
                headers = Headers().apply {
                    append("Content-Type", "application/json")
                },
                body = jsonData
            )
        ).await()
    } catch (e: Exception) {
        console.log("Error: $e")
        null
    }

    if (response?.ok == true) {
        onFinish("Submitted!")
    } else {
        onFinish("Error, try again later!")
    }
}

/*
    -------------------------------------

           DIESEL FUEL LOG FUNCTIONS

    -------------------------------------
*/
suspend fun submitDieselLogForm(
    dieselFuelLogDTO: DieselFuelLogDTO,
    onFinish: (String) -> Unit
) {
    val jsonSerializer = Json { encodeDefaults = true }
    val jsonData = jsonSerializer.encodeToString(dieselFuelLogDTO)

    val response: Response? = try {
        window.fetch(
            input = BackendRoutes.DIESEL_LOG,
            RequestInit(
                method = "POST",
                headers = Headers().apply {
                    append("Content-Type", "application/json")
                },
                body = jsonData
            )
        ).await()
    } catch (e: Exception) {
        console.log("Error: $e")
        null
    }

    if (response?.ok == true) {
        onFinish("Submitted!")
    } else {
        onFinish("Error, try again later!")
    }
}

/*
   -------------------------------------

          EQUIPMENT REPAIR FUNCTIONS

   -------------------------------------
   */
suspend fun submitEquipRepairForm(
    equipRepairRequestDTO: EquipRepairRequestDTO,
    onFinish: (String) -> Unit
) {
    val jsonSerializer = Json { encodeDefaults = true }
    val jsonData = jsonSerializer.encodeToString(equipRepairRequestDTO)

    val response: Response? = try {
        window.fetch(
            input = BackendRoutes.EQUIP_REPAIR,
            RequestInit(
                method = "POST",
                headers = Headers().apply {
                    append("Content-Type", "application/json")
                },
                body = jsonData
            )
        ).await()
    } catch (e: Exception) {
        console.log("Error: $e")
        null
    }

    if (response?.ok == true) {
        onFinish("Submitted!")
    } else {
        onFinish("Error, try again later!")
    }
}